import React from "react"

import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import classNames from "classnames/bind"
import styles from "../styles/LanguageSelection.module.scss"

import i18n from "../i18n/i18n"
import { setLang } from "../store/general"
import langMapping from "../constants/lang"

class LanguageSelection extends React.Component {
  changeLang = (lang) => {
    const { dispatch, history } = this.props
    dispatch(setLang(lang))
    i18n.changeLanguage(lang)
    history.push("/")
  }

  goBack = () => {
    const { history } = this.props
    history.goBack()
  }

  render() {
    const { lang } = this.props

    return (
      <>
        <div className={cn("close-btn")} onClick={this.goBack}>
          ✕
        </div>
        <h1 className={cn("title")}>Choose Your Language</h1>
        <div className={cn("language-list-wrapper")}>
          <ul className={cn("language-list")}>
            <li
              id="ko"
              className={cn("language-item", lang === "ko" && "selected")}
              onClick={() => {
                this.changeLang("ko")
              }}
            >
              {langMapping["ko"]}
            </li>
            <li
              id="en"
              className={cn("language-item", lang === "en" && "selected")}
              onClick={() => {
                this.changeLang("en")
              }}
            >
              {langMapping["en"]}
            </li>
            <li
              id="zh"
              className={cn("language-item", lang === "zh" && "selected")}
              onClick={() => {
                this.changeLang("zh")
              }}
            >
              {langMapping["zh"]}
            </li>
            <li
              id="jp"
              className={cn("language-item", lang === "jp" && "selected")}
              onClick={() => {
                this.changeLang("jp")
              }}
            >
              {langMapping["jp"]}
            </li>
            <li
              id="fr"
              className={cn("language-item", lang === "fr" && "selected")}
              onClick={() => {
                this.changeLang("fr")
              }}
            >
              {langMapping["fr"]}
            </li>
            <li
              id="de"
              className={cn("language-item", lang === "de" && "selected")}
              onClick={() => {
                this.changeLang("de")
              }}
            >
              {langMapping["de"]}
            </li>
            <li
              id="id"
              className={cn("language-item", lang === "id" && "selected")}
              onClick={() => {
                this.changeLang("id")
              }}
            >
              {langMapping["id"]}
            </li>
            <li
              id="it"
              className={cn("language-item", lang === "it" && "selected")}
              onClick={() => {
                this.changeLang("it")
              }}
            >
              {langMapping["it"]}
            </li>

            <li
              id="my"
              className={cn("language-item", lang === "my" && "selected")}
              onClick={() => {
                this.changeLang("my")
              }}
            >
              {langMapping["my"]}
            </li>
            <li
              id="pt"
              className={cn("language-item", lang === "pt" && "selected")}
              onClick={() => {
                this.changeLang("pt")
              }}
            >
              {langMapping["pt"]}
            </li>
            <li
              id="es"
              className={cn("language-item", lang === "es" && "selected")}
              onClick={() => {
                this.changeLang("es")
              }}
            >
              {langMapping["es"]}
            </li>
            <li
              id="vi"
              className={cn("language-item", lang === "vi" && "selected")}
              onClick={() => {
                this.changeLang("vi")
              }}
            >
              {langMapping["vi"]}
            </li>
            <li
              id="ar"
              className={cn("language-item", lang === "ar" && "selected")}
              onClick={() => {
                this.changeLang("ar")
              }}
            >
              {langMapping["ar"]}
            </li>
          </ul>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  lang: state.general.lang,
})

const cn = classNames.bind(styles)

export default withRouter(connect(mapStateToProps)(LanguageSelection))
